import React from 'react';
import { ChevronLeft, ChevronRight, CheckCircle, Loader2, X } from 'lucide-react';

export interface WizardNavLabels {
  finishLabel?: string;
  finishIcon?: React.ReactNode;
  submittingLabel?: string;
  cancelLabel?: string;
}

interface WizardNavigationProps {
  currentStep: number;
  totalSteps: number;
  canGoNext: boolean;
  canGoPrevious: boolean;
  isLastStep: boolean;
  isSubmitting?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onFinish: () => void;
  onCancel: () => void;
  labels?: WizardNavLabels;
}

const WizardNavigation: React.FC<Readonly<WizardNavigationProps>> = ({
  canGoNext,
  canGoPrevious,
  isLastStep,
  isSubmitting = false,
  onPrevious,
  onNext,
  onFinish,
  onCancel,
  labels = {},
}) => {
  const {
    finishLabel = 'Create Clinic',
    finishIcon = <CheckCircle size={18} />,
    submittingLabel = 'Creating...',
    cancelLabel = 'Cancel',
  } = labels;
  return (
    <div className="wizard-footer">
      <div className="wizard-footer-left">
        <button
          type="button"
          className="wizard-nav-btn cancel"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          <X size={18} />
          {cancelLabel}
        </button>
      </div>

      <div className="wizard-footer-right">
        <button
          type="button"
          className="wizard-nav-btn secondary"
          onClick={onPrevious}
          disabled={!canGoPrevious || isSubmitting}
        >
          <ChevronLeft size={18} />
          Back
        </button>

        {isLastStep ? (
          <button
            type="button"
            className="wizard-nav-btn finish"
            onClick={onFinish}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Loader2 size={18} className="spinner" />
                {submittingLabel}
              </>
            ) : (
              <>
                {finishIcon}
                {finishLabel}
              </>
            )}
          </button>
        ) : (
          <button
            type="button"
            className="wizard-nav-btn primary"
            onClick={onNext}
            disabled={!canGoNext || isSubmitting}
          >
            Next
            <ChevronRight size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default WizardNavigation;
